
import {toMoney } from "../../functions";
import { Atributo } from "../atributo";
import { Secao } from "../secao";
import { ISolicitacaoSenhaExcedentes } from "../../interfaces";

interface IDetalhesContasAPagarExcedidoProps {
  detalhes: ISolicitacaoSenhaExcedentes[];
}

export function DetalhesContaAPagarExcedido({
  detalhes,
}: IDetalhesContasAPagarExcedidoProps) {

  return (
    <>
      {detalhes && detalhes.length > 0 && (
        <Secao cabecalho="Parcelas de Contas a Pagar Excedido">
          <Atributo nome="Loja" valor={detalhes[0].codLoja} />

          <Atributo nome="Departamento" valor={detalhes[0].departamento} />

          <Atributo nome="Saldo Excedido" valor={toMoney(detalhes[0].valorTotalExcedente * -1)} />

          <Atributo nome="Mês" valor={""} />

          {detalhes.map((parcela) => (
            <Secao cabecalho={`${parcela.mesReferencia}`} cabecalhoClassName="destaque-mes-contas-pagar-excedido">

              <Atributo nome="Saldo Disponível" valor={toMoney(parcela.saldoDisponivel)} />

              <Atributo nome="Valor da Parcela" valor={toMoney(parcela.totalParcela)} />

              <Atributo nome="Valor Diferença" valor={toMoney(parcela.saldoDisponivel - parcela.totalParcela)} />

            </Secao>
          ))}
        </Secao>
      )}
    </>
  );
}
